import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IBewertungsAnlassSorter extends ISorter {
  id?: ISorterExpression;
  name?: ISorterExpression;
  beschreibung?: ISorterExpression;
}

export const BewertungsAnlassSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('name', 'Name'),
  SorterConfig('beschreibung', 'Beschreibung')
];
